import { Favorite, useFavorites } from 'app/state'
import { useCallback } from 'react'

export function useFavoriteForPath(path: string) {
  const [favorites, setFavorites] = useFavorites()
  const isFavorite = favorites.some((f) => f.path === path)

  const addFavorite = useCallback(
    (fav: Favorite) => {
      setFavorites((prev) => [...prev, fav])
    },
    [setFavorites]
  )

  const removeFavorite = useCallback(() => {
    setFavorites((prev) => prev.filter((f) => f.path !== path))
  }, [path, setFavorites])

  const renameFavorite = useCallback(
    (newName: string) => {
      setFavorites((prev) => prev.map((f) => (f.path === path ? { ...f, name: newName } : f)))
    },
    [path, setFavorites]
  )

  return { isFavorite, addFavorite, removeFavorite, renameFavorite }
}
